import React from 'react';
import styled from 'styled-components';
import Brand from '@catalogo/ui-americanas-desktop-svg/brand.svg';
import Airplane from '@catalogo/ui-americanas-desktop-svg/airplane.svg';

const Badge = ({ spacingLeft, spacingRight, svg, content, background, svgColor, textColor, svgWidth, svgHeight }) => (
  <Container background={background} spacingLeft={spacingLeft} spacingRight={spacingRight}>
    <Flexbox>
      {!!svg && (
        <Cell>
          {svg === 'icon-brand' && <Brand fill={svgColor} height={svgHeight} width={svgWidth} />}
          {svg === 'icon-airplane' && <Airplane fill={svgColor} height={svgHeight} width={svgWidth} />}
        </Cell>
      )}
      <Cell>
        <TextUI isSvg={svg} textColor={textColor} size="xs" spacing="xxs">
          {content}
        </TextUI>
      </Cell>
    </Flexbox>
  </Container>
);

const Container = styled.div`
  display: flex;
  min-height: 20px;
  border-radius: 4px;
  background: ${({ background }) => (background ? background : '#eee')};
  ${({ spacingLeft }) => spacingLeft && 'margin-left: 10px;'};
  ${({ spacingRight }) => spacingRight && 'margin-right: 10px;'};
`;

const Flexbox = styled.div`
  display: flex;
`;

const Cell = styled.div`
  display: flex;
  flex: auto;
  min-height: 1px;
  justify-content: center;
  align-items: center;
`;

const TextUI = styled.span`
  ${({ isSvg }) => (isSvg ? 'padding: 5px 5px 5px 0;' : 'padding: 5px;')};
  color: ${({ textColor }) => textColor && textColor};
  font-size: 14px;
`;

Badge.defaultProps = {
  background: '#eee',
  svgColor: '#333',
  textColor: '#666',
  svgWidth: '25',
  svgHeight: '26',
};

export default Badge;
